module.exports = __webpack_public_path__ + "static/MOTF-e36949ffe316bcfc323886ee3b019a61.jpg";